const translations = {
    acresTreated: 'Acres Treated',
    application: 'Application',
    applicationMethod: 'Method',
    applicationMethodAir: 'Air',
    applicationMethodGround: 'Ground',
    applicationRate: 'Application Rate',
    commodity: 'Commodity',
    mixIntervals: 'Mix intervals · most restrictive product',
    notSet: 'Not set',
    preHarvestInterval: 'Pre-Harvest Interval',
    reEntryInterval: 'Re-Entry Interval',
    unitAcres: 'ac',
    unitDays: 'days',
    unitFluidOuncesPerAcre: 'Fl. Oz/Ac',
    unitGallonsPerAcre: 'Ga/Ac',
    unitHours: 'hours',
    unitKilogramsPerSquareMeter: 'Kg/m²',
    unitLitersPerHectare: 'L/Ha',
    unitOuncesPerAcre: 'Oz/Ac',
    unitPintsPerAcre: 'Pt/Ac',
    unitPoundsPerAcre: 'Lb/Ac',
    unitQuartsPerAcre: 'Qt/Ac'
};

export default translations;
